enum StatsDuration {
  AllTime = "AllTime",
  OneDay = "OneDay",
  SevenDays = "SevenDays",
  ThirtyDays = "ThirtyDays",
}

export default StatsDuration;
